/**
 * The one address of an employer's ad: "Миний зарууд" with the business and the ad named.
 *
 * There used to be a second one — `/employer/my-posts?post=<id>`, a route whose whole
 * content was a single ad's applicant table. It opened one ad deep with nothing else on
 * screen and no way back to the rest without leaving the page, and it meant the same ad had
 * two links depending on which button you pressed. This is the surviving one, and every
 * "N анкет" pill, ad row and notification goes through here so it stays that way.
 *
 * The company is optional: a few older ads carry no companyId, and /employer/companies finds
 * the business the ad is filed under itself when it is missing.
 *
 * @param {string|number|null|undefined} companyId the business the ad belongs to
 * @param {string|number} jobId the ad
 * @returns {string} a path for navigate() / <Link to>
 */
export const employerAdPath = (companyId, jobId) => {
  const params = new URLSearchParams();
  if (companyId) params.set("company", String(companyId));
  params.set("job", String(jobId));
  return `/employer/companies?${params.toString()}`;
};

export default employerAdPath;
